import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ContentBox from '@components/ContentBox';
import Parallax from '@utility/Parallax';
import VideoPlayer from '@utility/VideoPlayer';
import ScrollInView from '@utility/ScrollInView/index';

const VideoTextOverlap = ({ data: { contentBox, video, reverse } }) => (
  <div className="wrapper">
    <div className="row">
      <div className="col-12">
        <VideoPlayer video={video} />
      </div>
    </div>
    <div className="row">
      <ScrollInView
        className={`col-11 md:col-5 -mt-4 md:-mt-32 ${
          reverse ? 'md:offset-7 offset-1' : ''
        }`}
      >
        <Parallax y={[20, -20]} contain={false}>
          <ContentBox data={contentBox} />
        </Parallax>
      </ScrollInView>
    </div>
  </div>
);

VideoTextOverlap.propTypes = {
  data: PropTypes.shape({
    video: PropTypes.object.isRequired,
    contentBox: PropTypes.object.isRequired,
    reverse: PropTypes.bool,
  }),
};

VideoTextOverlap.defaultProps = {
  data: {
    reverse: false,
  },
};

export default VideoTextOverlap;
